import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  menuLinks=[
    {
      url:'home',
      name:'Home'
    },
    {
      url:'about-us',
      name:'About'
    },
    {
      url:'about-ceo',
      name:'About CEO'
    },
    {
      url:'customer-reviews',
      name:'Customer Review'
    },
    {
      url:'careers',
      name:'Career'
    }
  ]

}
